export const contentKeys = {
  all: ['home-page'] as const,
  contentKpi: (accountId: string, isShowUnifiedFlow: boolean) =>
    ['contentKpi', accountId, isShowUnifiedFlow] as const,
  campaignMetrics: (id: string) =>
    [...contentKeys.all, 'campaingMetrics', id] as const,
  recentContents: (accountId: string) =>
    [...contentKeys.all, 'recentContents', accountId] as const,
  contentLibrary: (accountId: string) =>
    [...contentKeys.all, 'contentLibrary', accountId] as const,
  milestoneMetrics: (accountId: string) =>
    [...contentKeys.all, 'milestoneMetrics', accountId] as const,
}

export const welcomeMessageKey = 'daily_welcome_message'
